import React, {useRef, useState} from 'react';
import DatePicker, {
  ReactDatePickerProps,
  registerLocale,
} from 'react-datepicker';

import './styles.scss';
import 'react-datepicker/dist/react-datepicker.css';
import {Row} from '../../layout';
import {createClassName} from '../../../util/utility';
import Icon from '../../icon';
import {Icons} from '../../../util/icons';
import {compose} from 'redux';
import {connect} from 'react-redux';
import colors from '../../../util/colors';
import pt from 'date-fns/locale/pt'; // the locale you want
import srLatn from 'date-fns/locale/sr-Latn'; // the locale you want

interface AppDateInputProps extends ReactDatePickerProps {
  onChange(value: any): any;
  placeholder?: string;
  value: any;
  className?: string;
  buStyles: any;
  error?: string;
  noCalendar?: boolean;
  minDate?: Date;
  maxDate?: Date;
  language: string;
  userLanguage: string;
  dontShowYears?: boolean;
  defaultColor?: boolean;
}

function AppDateInput({
  onChange,
  placeholder,
  value,
  className,
  buStyles,
  error,
  noCalendar,
  minDate,
  maxDate,
  language,
  userLanguage,
  dontShowYears,
  defaultColor = false,
  ...rest
}: AppDateInputProps) {
  const currentLanguage = language || userLanguage;
  const dateInput = useRef(null);
  registerLocale('pt', pt);
  registerLocale('rs', srLatn);
  const classes = createClassName('datepicker-input-container', className);
  const [scrollSet, setScrollSet] = useState(false);
  const [open, setOpen] = useState(false);

  function formatDate(date: any) {
    var day;
    var month;
    var year;

    var newDate = new Date();

    if (date !== undefined) {
      if (date?.length === 10) {
        day = date.toString().substring(0, 2);
        month = date.toString().substring(2, 4);
        year = date.toString().substring(4, 8);
        newDate.setDate(day);
        newDate.setMonth(month - 1);
        newDate.setFullYear(year);
        if (!isNaN(newDate?.getDate()) && !isNaN(newDate?.getTime()))
          return newDate;
      }
    }
  }

  const setScroll = () => {
    var containers: HTMLCollection =
      document.getElementsByClassName('react-datepicker');
    var years: HTMLCollection = document.getElementsByClassName(
      'react-datepicker__year-dropdown--scrollable'
    );
  };

  const autoFormatDate = (e: any) => {
    var dateInput: HTMLInputElement = document.getElementsByClassName(
      'app-date-input'
    )[0] as HTMLInputElement;

    dateInput.maxLength = 10;

    if (dateInput && dateInput.value) {
      // Backspace detetion...
      dateInput.onkeydown = function (e: any) {
        if (e.key === 'Backspace')
          if (dateInput.value.length === 3 || dateInput.value.length === 6)
            // ... because, in this if case, it must delete the "/" character, plus the last number
            dateInput.value = dateInput.value.slice(0, -1);
      };

      // everytime the string reaches length === 2 or 5, a "/" char is added
      if (dateInput.value.length === 2) {
        dateInput.value = dateInput.value + '/';
      }
      if (dateInput.value.length === 5) {
        dateInput.value = dateInput.value + '/';
      }
    }
  };

  const openCalendar = () => {
    setOpen(true);
  };

  return (
    <label className="date-input-wrapper" onClick={(e) => e.preventDefault()}>
      <Row className={classes}>
        <DatePicker
          onClickOutside={() => {
            setScrollSet(false);
            setOpen(false);
          }}
          onInputClick={() => {
            setScrollSet(false);
            setOpen(true);
          }}
          ref={dateInput}
          open={open}
          placeholderText={placeholder}
          dropdownMode="scroll"
          showYearDropdown={!dontShowYears}
          scrollableYearDropdown
          yearDropdownItemNumber={50}
          maxDate={maxDate}
          locale={currentLanguage?.split('-')[0]}
          dateFormat="dd/MM/yyyy"
          onChange={(date: Date) => {
            onChange(date);
            setOpen(false);
          }}
          onChangeRaw={(date: any) => {
            onChange(formatDate(date.target.value));
            autoFormatDate(date);
            setOpen(false);
          }}
          className="app-text-input app-date-input"
          value={value}
          minDate={minDate}
          {...rest}
        />
        {error ? (
          <Icon
            width="24"
            height="24"
            className="app-form-field-error"
            name={Icons.ALERT_PROBLEM}
            color={colors.alertRed}
          />
        ) : (
          <>
            {!noCalendar && (
              <Icon
                color={buStyles?.primaryColor || colors.blue}
                className="calendar-icon"
                name={Icons.CALENDAR}
                width="14"
                height="14"
                onClick={openCalendar}
                changeViewbox={true}
              />
            )}
          </>
        )}
      </Row>
    </label>
  );
}

const mapStateToProps = ({globalStyles, language, user}: any) => ({
  buStyles: globalStyles.value,
  language: language.value,
  userLanguage: user.value.language,
});

export default compose(connect(mapStateToProps)(AppDateInput));
